import {ThunkDispatch, configureStore} from '@reduxjs/toolkit';
import {createReduxEnhancer} from '@sentry/react';
import {setAutoFreeze} from 'immer';
import {Action, combineReducers} from 'redux';
import {persistStore} from 'redux-persist';
import createSagaMiddleware from 'redux-saga';

import {location} from 'reducers/location/location';

import {cart} from './pages/cart/store/reducers';
import {addCartItemUpsell} from './pages/cart/store/reducers/addCartItemUpsell/addCartItemUpsell';
import {changeItemQty} from './pages/cart/store/reducers/changeItemQty/changeItemQty';
import {coupons} from './pages/cart/store/reducers/coupons/coupons';
import {payments} from './pages/cart/store/reducers/payments/payments';
import {cartUpsells} from './pages/cart/store/reducers/upsells/upsells';
import {checkoutSideReview} from './pages/checkout/store/reducers';
import {rootReducer as successPage} from './pages/success/store/store';
import {_checkoutSideReview} from './reducers/_checkoutSideReview';
import {cmsPopup} from './reducers/cmsPopup';

// Fixes "Cannot assign to read only property" error message
// when modifying objects from Redux state directly.
// https://github.com/reduxjs/redux-toolkit/issues/424
// but it's not a solution, we have to rewrite it to proper way
setAutoFreeze(false);

export const reducers = {
    _checkoutSideReview,
    addCartItemUpsell,
    cart,
    cartUpsells,
    changeItemQty,
    checkoutSideReview,
    cmsPopup,
    coupons,
    location,
    payments,
    successPage,
};

const rootReducer = combineReducers(reducers);
const sentryReduxEnhancer = createReduxEnhancer();

export const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    devTools: {name: 'MF Checkout desktop'},
    enhancers: getDefaultEnhancers => getDefaultEnhancers().concat(sentryReduxEnhancer),
    middleware: (getDefaultMiddleware): ReturnType<typeof getDefaultMiddleware> =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(sagaMiddleware) as unknown as ReturnType<typeof getDefaultMiddleware>,
    reducer: rootReducer,
});

export const persistor = persistStore(store);

export type AppDispatchType = typeof store.dispatch;

type ReducersType = typeof reducers;

export type ApplicationStoreType = {[k in keyof ReducersType]: ReturnType<ReducersType[k]>};

export type AppThunkDispatchType = ThunkDispatch<ApplicationStoreType, unknown, Action>;
